export const BOOTSTRAP_SESSION = 'BOOTSTRAP_SESSION';

export function bootstrapSession() {
  return { type: BOOTSTRAP_SESSION };
}
